import withUser from '@/withUser';
import Head from 'next/head';
import Header from '@components/Header';
import Breadcrumb, { BreadcrumbItem } from '@components/app/Breadcrumb';
import UIWidth from '@components/presentational/UIWidth';
import {
  Box,
  Heading,
  ListItem,
  Text,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';
import FrontLayout from '@layouts/FrontLayout';
import React from 'react';
import ResetPasswordForm from '@components/app/ResetPasswordForm';

function PageResetPassword() {
  return (
    <FrontLayout>
      <Head>
        <title>Mot de passe oublié | IFprofs</title>
      </Head>
      <Header />
      <Breadcrumb
        breadcrumbItems={[
          { label: 'Accueil', href: '/' },
          { label: 'Mot de passe oublié' },
        ]}
      >
        <BreadcrumbItem label="Accueil" as={'/'} href={'/'} />
        <BreadcrumbItem label="Mot de passe oublié" />
      </Breadcrumb>
      <UIWidth>
        <Heading
          as="h1"
          color="brand.100"
          fontSize={['2rem', '', '3.1875rem']}
          lineHeight={['2rem', '', '3.1875rem']}
          fontWeight="600"
        >
          Vous avez oublié votre mot de passe IFprofs ?
        </Heading>
        <VStack
          spacing="1rem"
          mt={{ base: '1rem', md: '1.5rem' }}
          align="stretch"
        >
          <Text>
            Rien de plus simple pour renouveler votre mot de passe&nbsp;:
          </Text>
          <UnorderedList>
            <ListItem>
              Saisissez l'adresse email de votre compte IFprofs
            </ListItem>
            <ListItem>Validez le formulaire</ListItem>
            <ListItem>
              Suivez les instructions du mail pour réinitialiser votre mot de
              passe.
            </ListItem>
          </UnorderedList>
          <Text>
            Si vous ne recevez pas de mail, n'oubliez pas de vérifier vos
            spams&nbsp;!
          </Text>
          <Box pb={{ base: '2.5rem', md: '3.5rem' }}>
            <ResetPasswordForm />
          </Box>
        </VStack>
      </UIWidth>
    </FrontLayout>
  );
}

export default withUser(PageResetPassword);
